import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';
import { TableListItemUniDriver } from '@wix/design-system/dist/testkit/unidriver';

export function PickerTableListItemUniDriver(base: UniDriver, body: UniDriver) {
  const tableListItem = TableListItemUniDriver(base, body);

  return {
    wait: (timeout?: number) => base.wait(timeout),
    hover: () => base.hover(),
    ...baseUniDriverFactory(base),
    ...tableListItem,
    // getTitleText: async () => base.$('[data-hook="selector-title"]').text(),
  };
}
